export const KICK_ACTOR_LABEL = "Kick";
export const KICK_AGENT_ACTOR_LABEL = "Kick agent";
export const AGENT_COMMENT_MARKER = `${KICK_AGENT_ACTOR_LABEL} ·`;
export const KICK_SUPPORT_LABEL = "Kick Support";
export const KICK_RULES_LABEL = "Rule";
export const PLATFORM_API_ACTOR_LABEL = "Platform API";

export const viaChannelLabel = (name: string, channelLabel: string) =>
    `${name} via ${channelLabel}`;
